module.exports = __webpack_public_path__ + "static/media/Building_Community_Header.536d6bdc.png";